import React,{useState} from "react";

import { MediaQueries } from "../../components/utils";
import { NavLink, useLocation } from "react-router-dom";
// import { postpostPlaceOrderapi } from "../../redux/paymentslice"
import { useDispatch, useSelector } from "react-redux";
import { Payment } from "../../actions";
import { useNavigate } from "react-router-dom";
import { setformmodal, setformstatus } from "../../redux/formslice";
import Modal from "./Modal";
import Cookies from "js-cookie";
import ClipLoader from "react-spinners/ClipLoader";
import { toggleMobileAddressModal } from "../../redux/addresslice";
import { pushToDataLayer } from "../utils/dataUserpush"
const Paymentdetails = () => {
  const { isMobile } = MediaQueries()
  const navigate = useNavigate();
  const location = useLocation();
  const { postpostPlaceOrderapi } = Payment()
  const dispatch = useDispatch()
  const paymentmethodsdata = useSelector((state) => state.paymentslice.paymentmethodsdata);
  const currentcountry = useSelector((state) => state.globalslice.currentcountry);
  const selecteddeafultoption = useSelector((state) => state.paymentslice.selecteddeafultoption);
  const addresslistdata = useSelector(state => state.addresslice.addresslistdata);
  const donationfee = useSelector(state => state.paymentslice.donationfee)
  const showdonation = useSelector(state => state.paymentslice.showdonation)
  const iscartpage = location.pathname === "/cart";
  const isaddresspage = location.pathname === "/deliveryaddress";
  const isPaymentPage = location.pathname === "/Payment";
  const [isLoading, setIsLoading] = useState(false);
  const cartlistdata = useSelector((state) => state.cartslice.cartlistdata);
  let cartIds = '';
  cartlistdata?.data?.result?.forEach((each) => {
    cartIds += `${each.product_id}|${each.quantity}|${each.single_price},`;
  });
  console.log(cartlistdata,"paymentmethodsdata")

  const placeorderclick = async () => {
    pushToDataLayer('begin_checkout', {
      currency: currentcountry.currency,
      value: parseInt(paymentmethodsdata.final_total.split(" ")[1]),
      items : cartlistdata?.data?.result?.map((each) => {
        return{
          item_id: each.product_id,
          item_name: each.name,
          item_category: each.subcategory_name,
          price: each.single_price,
          quantity: each.quantity
        }
      })
    });
    if (cartIds == '') {
      navigate("/cart");
    } else {
      setIsLoading(true)

      const input_data = {
        coupon_code: "",
        ...currentcountry.isDonationRequired && ({ donation_fee: showdonation ? donationfee : 0 }),
        notes: "Write user note here...",
        payment_method: selecteddeafultoption[0].payment_method,
        processing_fee: selecteddeafultoption[0].processing_fee,
        tabbyType: 1,
        ip_address: Cookies.get("cart_ip_address"),
        cartIds: cartIds
      }
     await postpostPlaceOrderapi(input_data)
     setIsLoading(false)

      pushToDataLayer("click_order", currentcountry.name, {
        payment_method: selecteddeafultoption[0]?.payment_method,
        amount: paymentmethodsdata.final_total
      });
    }

  }
  const addrespageclick = () => {
    if (cartIds == '') {
      navigate("/cart");
    } else if (addresslistdata?.data?.length > 0) {
      navigate("/Payment");
    } else {
      if (isMobile) {
        dispatch(toggleMobileAddressModal(true))
      } else {
        dispatch(setformstatus(3))
        dispatch(setformmodal(true))
      }
    }
  };

  return (
    <div>
      <div>
        <div className="payment-details-title">Price Details</div>
        {

          <div className="payment-type">
            <div className="payment-type-title">Subtotal </div>
            <div className="payment-type-cost">{paymentmethodsdata?.sub_total}</div>
          </div>
        }

        {/* <div className="payment-type">
          <div className="payment-type-title">Savings </div>
          <div className="payment-type-cost">-AED 0.00</div>
        </div> */}
        {
          <div className="payment-type">
            <div className="payment-type-title">Processing fee </div>
            {
              selecteddeafultoption && selecteddeafultoption.length > 0 ?
                <div className="payment-type-cost">{selecteddeafultoption?.[0]?.processing_fee}</div> :
                <div className="payment-type-cost">{paymentmethodsdata?.processing_fee}</div>
            }

          </div>
        }
        {
          currentcountry.isDonationRequired && showdonation &&
          <div className="payment-type">
            <div className="payment-type-title">Donation fee </div>
            <div className="payment-type-cost">{donationfee}</div>
          </div>
        }
        {
          <div className="payment-type-shipping">
            <div className="payment-type-shippingtitle">Shipping </div>
            <div className="payment-type-shippingtitle">{paymentmethodsdata?.shipping_charge}</div>
          </div>
        }
        {
          !isMobile &&
          <div className="form-border-bottom"></div>
        }

        {
          !isMobile &&
          <div>
            {
              // isPaymentPage &&
              <div className="payment-type  pb-2">


                <div className="payment-type-total">Total<span className="totalvat">(Inclusive of VAT)</span></div>

                <div className="payment-type-totalcost"><span className="pe-2">{currentcountry.currency} </span>
                  {(
                    Number(paymentmethodsdata?.final_total?.replace(/[^\d.]/g, '') || 0) +
                    (showdonation && currentcountry.isDonationRequired ? Number(donationfee || 0) : 0) +
                    Number(selecteddeafultoption?.[0]?.processing_fee || 0)
                  ).toFixed(2)}
                </div>


              </div>
            }
            {
              iscartpage &&
              <NavLink to="/deliveryaddress" className="textdecoration-none">
                <div className="payment-cost">Continue</div>
              </NavLink>


            }
            {
              isaddresspage &&
              // <NavLink to="/Payment" className="textdecoration-none"  >
              <div className="payment-cost" onClick={() => addrespageclick()}>Continue</div>
              // </NavLink>

            }
            {
              isPaymentPage &&
              <div className="payment-cost" onClick={placeorderclick}>Place Order
              {
                  isLoading &&
                  <ClipLoader className="ms-1" size={16} color={'#fff'} />
                }
              </div>

            }
          </div>
        }
      </div>
      {
        isMobile &&
        <div className="mobile_version_cart_bottom">
          <div className="mobile-payment-total">
            {
              // isPaymentPage &&

              <div className="payment-type pt-3 pb-2">


                <div className="payment-type-total">Total<span className="totalvat">(Inclusive of VAT)</span></div>
                <div className="payment-type-totalcost"> <span className="pe-2">{currentcountry.currency} </span>
                  {(
                    Number(paymentmethodsdata?.final_total?.replace(/[^\d.]/g, '') || 0) +
                    (showdonation ? Number(donationfee || 0) : 0) +
                    Number(selecteddeafultoption?.[0]?.processing_fee || 0)
                  ).toFixed(2)}
                </div>
              </div>
            }
            {
              iscartpage &&
              <NavLink to="/deliveryaddress" className="textdecoration-none">
                <div className="payment-cost">Continue</div>
              </NavLink>


            }
            {
              isaddresspage &&
              <div className="payment-cost" onClick={() => addrespageclick()}>Continue</div>
            }
            {
              isPaymentPage &&
              <div className="payment-cost" onClick={placeorderclick}>
                Place Order
                {
                  isLoading &&
                  <ClipLoader className="ms-1" size={16} color={'#fff'} />
                }
              </div>
            }

          </div>

        </div>
      }
      <Modal />
    </div>
  )
}
export default Paymentdetails;